import http from "@/shared/services/http.config";

type Id = string | number;

export const getQuotationTemplateList = () =>
  http.get("/vendors/quotation-template-list").then((res) => res.data);

export const saveQuotationTemplate = (payload: Record<string, any>) =>
  http.post("/vendors/quotation-template-save", payload).then((res) => res.data);

export const getQuotationTemplateDetail = (id: Id, params: Record<string, any> = {}) =>
  http.get(`/vendors/quotation-templates/${id}/detail`, { params }).then((res) => res.data);

export const deleteQuotationTemplate = (id: Id) =>
  http.delete(`/vendors/quotation-templates/${id}/delete`).then((res) => res.data);

export const getQuotationTemplateSections = (templateId: Id) =>
  http.get(`/vendors/quotation-templates/${templateId}/sections`).then((res) => res.data);

export const saveQuotationTemplateSections = (templateId: Id, payload: Record<string, any>) =>
  http
    .post(`/vendors/quotation-templates/${templateId}/save-sections`, payload)
    .then((res) => res.data);

// NOTE: backend route is defined as GET in the provided routes.
// Provide optional params for querystring payloads.
export const saveTemplateSectionItems = (sectionId: Id, params?: Record<string, any>) =>
  http
    .get(`/vendors/template-sections/${sectionId}/save-items`, params ? { params } : undefined)
    .then((res) => res.data);

export const getTemplateSectionItems = (sectionId: Id) =>
  http.get(`/vendors/template-sections/${sectionId}/items`).then((res) => res.data);

export const deleteQuotationTemplateSection = (sectionId: Id) =>
  http.delete(`/vendors/template-sections/${sectionId}/delete`).then((res) => res.data);

export const deleteTemplateSectionItem = (itemId: Id) =>
  http.delete(`/vendors/template-section-items/${itemId}/delete`).then((res) => res.data);
